<div class="headerhome-nav">
  <nav
    class="navbar bHTikb sticky-top navbar-default navbar-fixed-top buupass-box navbar-inverse navbar-theme navbar-theme-abs navbar-theme-transparent navbar-theme-border"
    id="main-nav">
    <div class="nav-overlay"></div>

    <div class="navbar-inner nav">
      <div class="navbar-header">
        <button class="navbar-toggle collapsed" data-target="#navbar-main" data-toggle="collapse" type="button"
          area-expanded="false">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>


        <a  class="navbar-brand-logo _mt-20" href="index.html">
          <img  src="assets/img/company1/buupass-lg.webp" alt="buupass.com" width="130" title="Image Title"/>
        </a>
      </div>
      <div class="collapse navbar-collapse" id="navbar-main">

        <ul class="nav navbar-nav pd-nav">
          <li>
            <a [href]="navLinks.buses" class="headerAccount" role="button">
              Buses
            </a>
          </li>
          <li>
            <a [href]="navLinks.hotels" class="headerAccount" role="button">
              Hotels
            </a>
          </li>
          <li>
            <a [href]="navLinks.trains"  class="headerAccount" role="button" rel="noopener noreferrer" target="_blank">
              Trains
            </a>
          </li>
          <li class="active">
            <a [href]="navLinks.flights" class="headerAccount" role="button">
              Flights
            </a>
          </li>

          <!-- <li >
          <a href="https://hire.buupass.com/"  role="button" >
            CAR HIRE
          </a>
        </li> -->


      </ul>

      <ul class="nav navbar-nav navbar-right">
        <li>
          <a target="_blank"  href="https://blog.buupass.com/" class="headerAccount" rel="noopener noreferrer">Blog</a>
        </li>
        <!-- <li>
          <a href="contact-us.html" class="headerAccount" role="button">
            Help
          </a>
        </li> -->
        @if (!isLoggedIn) {
          <li>
            <a id="openModalStart" data-toggle="modal" (click)="eventClick('Manage my account')" data-target="#manageBooking" class="headerAccount" role="button">
              Manage my account
            </a>
          </li>
        }
        <button id="openModalButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#myModal">Open Modal</button>
        <button id="openSignupButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#myCreateModal">Open Modal</button>
        <button id="openSuccessButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#signupSuccess">Open Modal</button>
        <button id="openModalReset"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#resetPassModal">Open Modal</button>
        <button id="openOtpCodeButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#otpCodeModal">Open Modal</button>
        <button id="openUpdatePassword"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#passwordUpdateModal">Open Modal</button>
        <button id="openResetSuccessButton"  [class.is-hidden]="isHidden" data-toggle="modal" data-target="#resetSuccess">Open Modal</button>


        <!-- <li>
        <a data-toggle="modal" data-target="#myModal" class="headerAccount" role="button">
          Sign in
        </a>

      </li>
      <li>
        <a  data-toggle="modal" data-target="#myCreateModal"  class="headerAccount" role="button">
          Create an account
        </a>
      </li> -->
      @if (isLoggedIn) {
        <li class="navbar-nav-item-user">
          <a [href]="accountUrl" class="headerAccount account-badge-link" role="button" [attr.title]="accountDisplayName">
            <span class="account-avatar-badge" aria-hidden="true">{{ accountInitials }}</span>
            <span class="account-badge-name">{{ accountDisplayName }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
</div>

</nav>
</div>

<!-- Modal: Sign In – Step 01 -->
<div id="manageBooking" class="modal fade auth-modal" role="dialog">
  <div class="modal-dialog auth-modal-dialog" role="document">
    <div class="modal-content auth-modal-content">

        <!-- Left branding panel -->
      <div class="auth-left-panel">
        <div class="auth-left-inner">
          <div class="auth-brand-lockup">
            <div class="auth-brand-badge">
              <img src="assets/img/company1/logo.png" alt="BuuPass" class="auth-logo">
            </div>
            <span class="auth-brand-note">Trusted travel booking</span>
          </div>
          <div class="auth-hero">
            <span class="auth-welcome-label">Welcome Back</span>
            <h2 class="auth-heading">Every journey<br><em class="auth-highlight">starts here.</em></h2>
            <p class="auth-sub">Sign in to manage bookings, receive notifications and keep your trips in one place.</p>
          </div>
          <div class="auth-stats">
            <div class="auth-stat"><span class="auth-stat-num">30M+</span><span class="auth-stat-lbl">Travellers</span></div>
            <div class="auth-stat-div"></div>
            <div class="auth-stat"><span class="auth-stat-num">350+</span><span class="auth-stat-lbl">Routes</span></div>
            <div class="auth-stat-div"></div>
            <div class="auth-stat"><span class="auth-stat-num">100+</span><span class="auth-stat-lbl">Operators</span></div>
          </div>
        </div>
      </div>

      <!-- Right form panel -->
      <div class="auth-right-panel">
        <button id="closeStart" (click)="eventClick('Close Manage my account')" type="button" class="auth-close-btn" data-dismiss="modal">&times;</button>
        <div class="auth-right-inner">
          <div class="auth-step-badge">Step 01 / 02</div>
          <h3 class="auth-form-title">Sign in to buupass</h3>
          <p class="auth-form-sub">Continue with your mobile number or email — we'll send a one-time code.</p>

          <form [formGroup]="startForm" id="ngFormStart" (ngSubmit)="otpSignUp()">
            <div class="auth-field-group">
              <label class="auth-field-label">Mobile Number or Email</label>
              <input type="text"
                class="auth-input"
                id="inlineFormInputPhoneContinue"
                placeholder="e.g. 0712345678 or you&#64;email.com"
                name="phone_or_email"
                formControlName="phone_or_email">
              @if (startForm.get('phone_or_email').touched && startForm.get('phone_or_email').hasError('required')) {
                <small class="auth-error">This field is required!</small>
              }
              @if (startForm.get('phone_or_email').touched && startForm.get('phone_or_email').hasError('invalidContact')) {
                <small class="auth-error">Please enter a valid phone number or email</small>
              }
            </div>

            @if (!loadingStart && api_error) {
              <div class="auth-api-error">{{api_error.getErrorMessage()}}</div>
            }

            <div class="auth-terms-group">
              <label class="auth-checkbox-label">
                <input class="auth-checkbox" type="checkbox" (click)="acceptedTerms()" required="">
                <span class="auth-terms-text">By continuing, you agree to receive an OTP via SMS or Email from Buupass to login to your account</span>
              </label>
              @if (numberSubmitted && !this.accepted_terms) {
                <small class="auth-error">Please accept the terms and condition</small>
              }
            </div>

            <button [disabled]="!startForm.valid || !this.accepted_terms" form="ngFormStart" class="auth-submit-btn">
              @if (loadingStart) {
                <img src="assets/img/gifs/rll.gif" class="auth-loading-gif">
              }
              @if (!loadingStart) {
                <span>Send my code</span>
                <span class="auth-btn-arrow">&#8594;</span>
              }
            </button>
          </form>

          <p class="auth-tc-link"><a href="/BuuPass_Website_Terms_of_Use.pdf" target="_blank">Terms &amp; conditions</a></p>
        </div>
      </div>

    </div>
  </div>
</div>

  <!-- Modal: Enter OTP – Step 02 -->
  <div id="otpCodeModal" class="modal fade auth-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog auth-modal-dialog" role="document">
      <div class="modal-content auth-modal-content">

        <!-- Left branding panel -->
        <div class="auth-left-panel">
          <div class="auth-left-inner">
            <div class="auth-brand-lockup">
              <div class="auth-brand-badge">
                <img src="assets/img/company1/buupass-transparent.png" alt="BuuPass" class="auth-logo">
              </div>
              <span class="auth-brand-note">Trusted travel booking</span>
            </div>
            <div class="auth-hero">
              <span class="auth-welcome-label">Almost there</span>
              <h2 class="auth-heading">Check your<br><em class="auth-highlight">{{is_email_otp ? 'inbox.' : 'messages.'}}</em></h2>
              <p class="auth-sub">We've sent a one-time code to your {{is_email_otp ? 'email address' : 'mobile number'}}. It expires in 2 minutes.</p>
            </div>
            <div class="auth-stats">
              <div class="auth-stat"><span class="auth-stat-num">1.2M+</span><span class="auth-stat-lbl">Travellers</span></div>
              <div class="auth-stat-div"></div>
              <div class="auth-stat"><span class="auth-stat-num">340</span><span class="auth-stat-lbl">Routes</span></div>
              <div class="auth-stat-div"></div>
              <div class="auth-stat"><span class="auth-stat-num">86</span><span class="auth-stat-lbl">Operators</span></div>
            </div>
          </div>
        </div>

        <!-- Right form panel -->
        <div class="auth-right-panel">
          <button id="closeCode" (click)="eventClick('Close OTP')" type="button" class="auth-close-btn" data-dismiss="modal" aria-label="Close">&times;</button>
          <div class="auth-right-inner">
            <div class="auth-step-badge">Step 02 / 02</div>
            <h3 class="auth-form-title">Enter your code</h3>
            <p class="auth-form-sub">OTP has been sent to your {{is_email_otp ? 'email' : 'mobile'}}.</p>

            <form [formGroup]="codeForm" id="codeForm" (ngSubmit)="otpSubmitCode()">
              <div class="auth-field-group">
                <label class="auth-field-label">One-Time Code</label>
                <input
                  type="text"
                  id="otp_code"
                  class="auth-input auth-otp-input"
                  placeholder="_ _ _ _"
                  formControlName="otp_code">
                @if (codeForm.get('otp_code').touched && codeForm.get('otp_code').hasError('required')) {
                  <small class="auth-error">Please enter a code</small>
                }
              </div>

              @if (!codeubmitted && api_error) {
                <div class="auth-api-error">{{ codeSuccessMsg }}</div>
              }

              <button form="codeForm" type="submit" class="auth-submit-btn" [disabled]="loadingCode">
                @if (loadingCode) {
                  <img src="assets/img/gifs/rll.gif" class="auth-loading-gif">
                }
                @if (!loadingCode) {
                  <span>Verify code@if (!canResend) {<span class="auth-timer"> ({{ timer }}s)</span>}</span>
                  <span class="auth-btn-arrow">&#8594;</span>
                }
              </button>

              <button type="button" class="auth-resend-btn" (click)="resendOtpCode()" [disabled]="!canResend || resendingOtp">
                @if (!resendingOtp) { <span>Resend OTP</span> }
                @if (resendingOtp) { <img src="assets/img/gifs/rll.gif" class="auth-loading-gif"> }
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Modal -->
  <div id="resetPassModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button id="closeReset" type="button" class="close" data-dismiss="modal">&times;</button>
          <br>
            <div class="modal-body">
              <h4 class="theme-payment-page-signin-title review-header _ml-15">Recover your account  </h4>
              <div class="facebook-login__disclaimer  _mb-20 _ml-15">
                <p class="paragraphRegular">We can help you reset your password. First, enter your email and follow the instructions.</p>
              </div>
              @if (!resetsubmitted &&  successReset) {
                <div class="success-feedback">
                  <div class="success-select _ml-10"  >{{resetSuccessMsg}}</div>
                </div>
              }
              <!-- <div class="or__splitter"><span>or</span></div> -->
              <form [formGroup]="resetForm" id="resetForm" (ngSubmit)="submitResetPassword()" >
                <div class="form-row  _mb-20 ">
                  <div class="col-sm-8 my-1">
                    <label class="sr-only" for="inlineFormInputEmailHome">Email</label>
                    <input type="text"
                      class="form-control"
                      id="inlineFormInputEmailHome"
                      placeholder="e.g your@email.com"
                      name="email"
                      formControlName="email"
                      >
                  </div>
                  <div class="col-auto my-1">
                    <button   form="resetForm" class="theme-search-area-submit theme-search-area-submit-curved theme-search-area-submit-glow">
                      @if (loadingReset) {
                        <img src="assets/img/gifs/rll.gif">
                      }
                      @if (!loadingReset) {
                        <span>SUBMIT</span>
                      }
                    </button>
                  </div>
                </div>
              </form>

              @if (!resetsubmitted &&  api_error) {
                <div class="invalid-feedback">
                  <div class="invalid-select _ml-10"  >{{resetErrMsg}}</div>
                </div>
              }
              @if (resetForm.get('email').touched && resetForm.get('email').hasError('required')) {
                <small class=" _ml-10 invalid-select">Please enter your email</small>
              }
              @if (resetForm.get('email').touched && resetForm.get('email').hasError('email')) {
                <small class=" _ml-10 invalid-select">Should be a valid email address</small>
              }

            </div>

          </div>

        </div>
      </div>
    </div>



    <!-- Modal update password -->
    <div id="passwordUpdateModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button id="closePasswordUpdate" type="button" class="close" data-dismiss="modal">&times;</button>
            <br>
              <div class="modal-body">
                <h4 class="theme-payment-page-signin-title review-header _ml-15">    Reset your password       </h4>
                <div class="facebook-login__disclaimer  _mb-20 _ml-15">
                  <p class="paragraphRegular">8-character minimum; case sensitive.</p>
                </div>
                <!-- <div class="or__splitter"><span>or</span></div> -->
                <form [formGroup]="passwordUpdateForm" id="passwordUpdateForm" (ngSubmit)="updatePassword()" >
                  <div class="form-row  _mb-20 ">
                    <div class="col-sm-6 my-1">
                      <label class="sr-only" for="inlineFormInputPassword">Password</label>
                      <input type="password"
                        class="form-control"
                        id="inlineFormInputPassword"
                        placeholder="Password"
                        name="password"
                        formControlName="password"
                        >
                    </div>
                    <div class="col-sm-6 my-1">
                      <label class="sr-only" for="inlineFormInputConfirmPassword">Re-enter Password</label>
                      <input type="password"
                        class="form-control"
                        id="inlineFormInputConfirmPassword"
                        placeholder="Re-enter Password"
                        name="confirmpassword"
                        formControlName="confirmpassword"
                        >
                    </div>
                  </div>
                  <div class="form-row  _mb-20 ">
                    <div class="col-sm-6 my-1 _mt-20">
                      <button   form="passwordUpdateForm" class="theme-search-area-submit theme-search-area-submit-curved theme-search-area-submit-glow">
                        @if (loadingPasswordUpdate) {
                          <img src="assets/img/gifs/rll.gif">
                        }
                        @if (!loadingPasswordUpdate) {
                          <span>SUBMIT</span>
                        }
                      </button>
                    </div>
                  </div>

                </form>

                @if (!codeubmitted &&  api_error) {
                  <div class="invalid-feedback">
                    <div class="invalid-select _ml-10"  >{{codeSuccessMsg}}</div>
                  </div>
                }
                <div class="row">
                  @if (passwordUpdateForm.get('password').touched && passwordUpdateForm.get('password').hasError('required')) {
                    <small class=" _ml-10 invalid-select">Please enter a code </small>
                  }
                  @if (passwordUpdateForm.get('password').touched && passwordUpdateForm.get('password').hasError('minlength')) {
                    <small class=" _ml-10 invalid-select">Should be 8-character minimum.</small>
                  }
                  @if (passwordUpdateForm.get('confirmpassword').touched && passwordUpdateForm.get('confirmpassword').hasError('confirmedValidator') ) {
                    <small class=" _ml-10 invalid-select">Password and Confirm Password must be match.</small>
                  }

                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- Modal -->
      <div id="signupSuccess" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button id="closeSuccess" type="button" class="close" data-dismiss="modal">&times;</button>
              <br>
                <div class="modal-body">
                  <h4 class="theme-payment-page-signin-title review-header _ml-10">Success</h4>

                  <div class="facebook-login__disclaimer  _mb-20 _ml-10">

                    <p class="paragraphRegular">Thank you for registering with Buupass, kindly go to your email and click the confirmation link. Thank you .</p>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
        <!-- Modal -->
        <div id="resetSuccess" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <button id="closeResetSuccess" type="button" class="close" data-dismiss="modal">&times;</button>
                <br>
                  <div class="modal-body">
                    <h4 class="theme-payment-page-signin-title review-header _ml-10">Success</h4>

                    <div class="facebook-login__disclaimer  _mb-20 _ml-10">

                      <p class="paragraphRegular">Your password has been updated successfully. Thank you .</p>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <!-- Modal -->
          <div id="myModal" class="modal fade auth-modal" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <i (click)="backToEmail()" class="fa fa-arrow-left  back-btn" aria-hidden="true"></i>
                  <button  id="closePassword" type="button" class="close" data-dismiss="modal">&times;</button>
                  <br>
                  </div>
                  <div class="modal-body">
                    <form [formGroup]="loginForm" id="ngFormLogin" (ngSubmit)="submitLogin()" >
                      <h4 class="theme-payment-page-signin-title review-header  _ml-15">Welcome back</h4>
                      <div class="facebook-login__disclaimer _ml-15">
                        <p class="paragraphRegular">Please enter your password to continue.</p>
                      </div>
                      <div class="row">
                        <div class="col-md-8 _ml-15">
                          <div class="row" data-gutter="10">
                            <div class="col-md-12 mfb-form__row">
                              <div
                                class="theme-search-area-section first theme-search-area-section-border-light theme-search-area-section-curved">
                                <div class="theme-search-area-section-inner">
                                  <input
                                    name="password"
                                    id="password-field"
                                    formControlName="password"
                                    class="theme-header-section-input typeahead"
                                    [type]="fieldTextType ? 'text' : 'password'"
                                    placeholder=""  >
                                  <span  class="fa fa-fw  field-icon toggle-password"
                      [ngClass]="{
                                  'fa-eye-slash': !fieldTextType,
                                  'fa-eye': fieldTextType
                                }"
                                    (click)="toggleFieldTextType()"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            @if (!loginsubmitted &&  api_error) {
                              <div class="invalid-feedback">
                                <div class="invalid-select _ml-5"  >{{api_error.getErrorMessage()}}</div>
                              </div>
                            }
                            <div class="row mfb-form__row user-login-form__row__pass-reset ">
                              <div class="col-xs-12 user-login-form__pass-reset _ml-5"><a class="user-login-form__link" (click)="initiateResetPassword()" href="#">Can’t access your account?</a></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2 col-md-offset-8">
                          <button class="theme-search-area-submit theme-search-area-submit-curved theme-search-area-submit-glow">
                            @if (loadingLogin) {
                              <img src="assets/img/gifs/rll.gif">
                            }
                            @if (!loadingLogin) {
                              <span>SUBMIT</span>
                            }
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
            <!-- Modal -->
            <div id="myCreateModal" class="modal fade auth-modal" role="dialog">
              <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <button id="closeSignup" type="button" class="close" data-dismiss="modal">&times;</button>
                    <br>
                      <h4 class="theme-payment-page-signin-title review-header _mb-10 text-center">Sign up</h4>
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      <div class="modal-body">
                        <form class="makeFlex" id="ngFormSignup" novalidate [formGroup]="signupForm" (ngSubmit)="submitSignUp()">
                          <div class="trvlrs-dtl _ml-30">
                            <div class="c-accordion-item  expanded">
                              <div class="accordion-body" style="display: block;">
                                <div class="general-error"></div>
                                <div class="trvlr-forms-cntnr u-ib">
                                  <div class="trvlr-form-cntnr">
                                    <div class="trvlr-form">
                                      <div >
                                        <div class="form-hdr"><i class="text-light fa fa-bookmark"></i> Account Details</div>
                                        <div class="row" data-gutter="30">
                                          <div class="col-md-6">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label for="first_name" class="theme-search-area-section-label">Firstname</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="text"
                                                  name="first_name"
                                                  id="first_name"
                                                  placeholder=""
                                                  tabindex="0"
                                                  formControlName="first_name"
                                                  >
                                              </div>
                                              @if (submitted && f.first_name.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.first_name.errors.required) {
                                                    <div class="invalid-select">First name is required!</div>
                                                  }
                                                  @if (f.first_name.errors.pattern) {
                                                    <div class="invalid-select">Your firstname should not contain numbers or spaces</div>
                                                  }
                                                </div>
                                              }
                                              @if (!loadingSignup &&  user) {
                                                <div class="invalid-feedback">
                                                  <div class="invalid-select "  >{{user.getFname()}}</div>
                                                </div>
                                              }

                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label  for="last_name" class="theme-search-area-section-label">Lastname</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="text"
                                                  name="last_name"
                                                  id="last_name"
                                                  tabindex="0"
                                                  formControlName="last_name"
                                                  >
                                              </div>
                                              @if (submitted && f.last_name.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.last_name.errors.required) {
                                                    <div class="invalid-select">Firstname is required!</div>
                                                  }
                                                  @if (f.last_name.errors.pattern) {
                                                    <div class="invalid-select">Your lastname should not contain numbers or spaces</div>
                                                  }
                                                </div>
                                              }
                                              @if (!loadingSignup &&  user) {
                                                <div class="invalid-feedback">
                                                  <div class="invalid-select "  >{{user.getLname()}}</div>
                                                </div>
                                              }
                                            </div>
                                          </div>



                                        </div>
                                        <div class="row" data-gutter="30">
                                          <div class="col-md-6 ">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label for="phone_number" class="theme-search-area-section-label">Phone Number</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="text"
                                                  name="phone_number"
                                                  id="phone_number"
                                                  placeholder=""
                                                  tabindex="0"
                                                  formControlName="phone_number"
                                                  >
                                              </div>
                                              @if (submitted && f.phone_number.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.phone_number.errors.required) {
                                                    <div class="invalid-select">Phone number is required!</div>
                                                  }
                                                  @if (f.phone_number.errors.pattern) {
                                                    <div class="invalid-select">Input a valid Phone Number. Sample formats (+254******)</div>
                                                  }
                                                </div>
                                              }
                                              @if (!loadingSignup &&  user) {
                                                <div class="invalid-feedback">
                                                  <div class="invalid-select "  >{{user.getPhone()}}</div>
                                                </div>
                                              }

                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label for="id_number" class="theme-search-area-section-label">ID/Passport</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="text"
                                                  name="id_number"
                                                  id="id_number"
                                                  placeholder=""
                                                  type="text"
                                                  tabindex="0"
                                                  formControlName="id_number"
                                                  >
                                              </div>
                                              @if (submitted && f.id_number.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.id_number.errors.minlength) {
                                                    <div class="invalid-select">ID/PASSPORT should be between 7 to 14 characters</div>
                                                  }
                                                  @if (f.id_number.errors.maxlength) {
                                                    <div class="invalid-select">ID/PASSPORT should be between 7 to 14 characters</div>
                                                  }
                                                  @if (f.id_number.errors.required) {
                                                    <div class="invalid-select">ID/PASSPORT is required!</div>
                                                  }
                                                  @if (f.id_number.errors.pattern) {
                                                    <div class="invalid-select">ID/PASSPORT must be between 7 to 14 characters</div>
                                                  }
                                                </div>
                                              }
                                              @if (!loadingSignup &&  user) {
                                                <div class="invalid-feedback">
                                                  <div class="invalid-select "  >{{user.getIdno()}}</div>
                                                </div>
                                              }
                                            </div>
                                          </div>

                                        </div>
                                        <div class="row" data-gutter="30">
                                          <div class="col-md-12">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label for="email" class="theme-search-area-section-label">Email</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="text"
                                                  placeholder="Email"
                                                  name="email"
                                                  id="email"
                                                  placeholder=""
                                                  tabindex="0"
                                                  formControlName="email"
                                                  >
                                              </div>
                                              @if (submitted && f.email.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.email.errors.required) {
                                                    <div class="invalid-select">Email is required!</div>
                                                  }
                                                  @if (f.email.errors.email) {
                                                    <div class="invalid-select">Email must be a valid email address</div>
                                                  }
                                                </div>
                                              }
                                              @if (!loadingSignup &&  user) {
                                                <div class="invalid-feedback">
                                                  <div class="invalid-select "  >{{user.getEmail()}}</div>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row" data-gutter="30">
                                          <div class="col-md-12">
                                            <div class="theme-search-area-section first theme-search-area-section-line">
                                              <label for="email" class="theme-search-area-section-label">Password</label>
                                              <div class="theme-search-area-section-inner">
                                                <input class="theme-search-area-section-input typeahead"
                                                  type="password"
                                                  placeholder="Your pasword"
                                                  name="password"
                                                  id="password"
                                                  placeholder=""
                                                  tabindex="0"
                                                  formControlName="password"
                                                  >
                                              </div>
                                              @if (submitted && f.password.errors) {
                                                <div class="invalid-feedback">
                                                  @if (f.password.errors.required) {
                                                    <div class="invalid-select">Password is required!</div>
                                                  }
                                                  @if (f.password.errors.minlength) {
                                                    <div class="invalid-select">Your password should not be less than 6 characters</div>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="trvlr-list-cntnr u-ib">
                                  <div class="c-trvlr-list-wrpr">
                                    <div class="c-trvlr-list-cntnr u-cstm-scroll" style="max-height: 250px;">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row _mt-20 ">
                              <div class="col-md-3 col-md-offset-7">
                                <button type="submit"  class=" _ml-30 theme-search-area-submit btn-block theme-search-area-submit-curved  theme-search-area-submit-glow">
                                  @if (loadingSignup) {
                                    <img src="assets/img/gifs/rll.gif">
                                  }
                                  @if (!loadingSignup) {
                                    <span>SUBMIT</span>
                                  }

                                </button>
                              </div>
                            </div>
                          </div>
                        </form>

                        <p class="text-center _mt-10">By creating an account you agree to our
                        Terms of Use and Privacy Policy</p>

                      </div>

                    </div>

                  </div>
                </div>
              </div>
